import _ from 'lodash';
import { createSelector } from 'reselect';

// state selector
const customer = state => state.stripeCustomer;

const getCustomerSubscriptionsList = myCustomer => {
  if (process.env.NODE_ENV !== 'production') {
    console.log('CustomerSubscriptionsListSelector customer', myCustomer);
  }
  if (myCustomer.error) {
    return { error: myCustomer.error };
  }
  if (myCustomer.status === 'loading') {
    return { status: myCustomer.status };
  }

  let subscriptions = [];
  if (
    myCustomer &&
    myCustomer.subscriptions &&
    myCustomer.subscriptions.data &&
    myCustomer.subscriptions.data.length > 0
  ) {
    subscriptions = _.map(myCustomer.subscriptions.data, subscription => {
      // assume that all plans are either Spanish 'something' or Rype 'something'
      const items = subscription.items && subscription.items.data;
      const item = items && items.find(i => i.plan.id === subscription.plan.id);

      return {
        status: subscription.status,
        stripePlanId: subscription.plan.id,
        stripeSubscriptionId: subscription.id,
        stripeSubscriptionItemId: item && item.id,
        trialEnd: subscription.trial_end,
        currentPeriodStart: subscription.current_period_start,
        currentPeriodEnd: subscription.current_period_end,
        created: subscription.created,
        amount: item.plan.amount
      };
    });
  }

  return {
    data: subscriptions
  };
};

export default createSelector(
  // state selecting functions which are updated
  // whenever the global state changes
  customer,
  // function containing selector logic
  getCustomerSubscriptionsList
);



// WEBPACK FOOTER //
// ./src/selectors/CustomerSubscriptionsSelector.js